module.exports = __webpack_public_path__ + "static/media/bespoke-footer-icon.393b05db.jpg";